import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';

import {
	AuthDetailParams,
	GetAuthDetail,
	GetAuthDetailModel,
} from 'domain/usecases/private/authorizations';

export class RemoteGetAuthDetail implements GetAuthDetail {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetAuthDetailModel>,
	) {}

	async get(params?: AuthDetailParams): Promise<GetAuthDetailModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			signal: params?.signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
